import cn from 'classnames';

import Heading from 'components/common/Heading';
import ToggleButton from 'components/common/ToggleButton';
import CalorieConsciousIcon from 'components/icons/CalorieConsciousIcon';
import CarbConsciousIcon from 'components/icons/CarbConsciousIcon';
import EatAnythingIcon from 'components/icons/EatAnythingIcon';
import FiberRichIcon from 'components/icons/FiberRichIcon';
import GlpBalancedIcon from 'components/icons/GlpBalancedIcon';
import GlutenSmartIcon from 'components/icons/GlutenSmartIcon';
import KetoFriendlyIcon from 'components/icons/KetoFriendlyIcon';
import MediterraneanIcon from 'components/icons/MediterraneanIcon';
import PescatarianIcon from 'components/icons/PescatarianIcon';
import ProteinPackedIcon from 'components/icons/ProteinPackedIcon';
import VegetarianIcon from 'components/icons/VegetarianIcon';
import { HOME_CHEF, TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import {
  GLUTEN_SMART,
  CALORIE_CONSCIOUS,
  MEDITERRANEAN,
  CARB_CONSCIOUS,
  EAT_ANYTHING,
  KETO_FRIENDLY,
  PESCATARIAN,
  HIGH_PROTEIN,
  GLP_BALANCED,
  VEGETARIAN,
  FIBER_RICH,
} from 'lib/constants';

const IconMap = {
  [CALORIE_CONSCIOUS]: CalorieConsciousIcon,
  [CARB_CONSCIOUS]: CarbConsciousIcon,
  [FIBER_RICH]: FiberRichIcon,
  [GLP_BALANCED]: GlpBalancedIcon,
  [GLUTEN_SMART]: GlutenSmartIcon,
  [EAT_ANYTHING]: EatAnythingIcon,
  [KETO_FRIENDLY]: KetoFriendlyIcon,
  [MEDITERRANEAN]: MediterraneanIcon,
  [PESCATARIAN]: PescatarianIcon,
  [HIGH_PROTEIN]: ProteinPackedIcon,
  [VEGETARIAN]: VegetarianIcon,
};

const DietaryPreferencesForm = ({
  header = '',
  subheader = '',
  containerClassName,
  gridClassName,
  preferences,
  handlePreferencesClick,
}) => {
  const isHomeChef = useBrand(HOME_CHEF);
  const isTempo = useBrand(TEMPO);

  return (
    <>
      <Heading className={'mb-2 px-6 text-center bp2:px-60 bp3:px-80'}>{header}</Heading>
      <div className={containerClassName}>
        <section>
          <Heading
            brandStylesOverrides="h6 text"
            className={cn(
              {
                'font-normal': isHomeChef,
              },
              'pb-4 text-center'
            )}
          >
            {subheader}
          </Heading>
          <div className={`grid w-full grid-cols-1 gap-x-1.5 gap-y-2 ${gridClassName}`}>
            {preferences?.dietaryPreferences.map(preference => {
              const IconComponent = IconMap[preference.friendlyName];
              return (
                <ToggleButton
                  id={preference.id}
                  className="relative flex h-14 w-full items-center justify-between rounded px-3"
                  name={preference.friendlyName}
                  selected={preference.selected}
                  handleClick={() => handlePreferencesClick(preference)}
                  type="preference"
                  role="checkbox"
                  aria-checked={preference.selected}
                  aria-label={preference.friendlyName}
                  key={`column-${preference.id}`}
                >
                  {preference.friendlyName === GLUTEN_SMART
                    ? `${preference.friendlyName}*`
                    : preference.friendlyName}
                  {IconComponent && (
                    <IconComponent
                      className="ml-3 h-8 w-8"
                      hcSelected={isHomeChef && preference.selected}
                      tempoSelected={isTempo && preference.selected}
                    />
                  )}
                </ToggleButton>
              );
            })}
          </div>
        </section>
      </div>
    </>
  );
};

DietaryPreferencesForm.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string,
  containerClassName: PropTypes.string,
  gridClassName: PropTypes.string,
  preferences: PropTypes.object,
  handlePreferencesClick: PropTypes.func,
};

export default DietaryPreferencesForm;
